import React, { FC, useEffect, useState } from "react";
import { API_URL } from "../../../../actions/settings";
import { IonRow } from "@ionic/react";
import BoxPlot from "../../../extras/BoxPlot";

async function getSuggestions(token: string, id: any) {
  return fetch(`${API_URL}/benchmark/suggested_rates/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
    return res.json();
  });
}

interface IProps {
    id : string | null | undefined;
};

interface Suggestion {
    "median_kwh_per_sqft": number,
    "median_therms_per_sqft": number,
    "min_kwh_per_sqft": number,
    "max_kwh_per_sqft": number,
    "min_therms_per_sqft": number,
    "max_therms_per_sqft": number,
    "kwh_rates": number[],
    "therm_rates": number[]
}

const defaultSuggestion = {
    "median_kwh_per_sqft": 0,
    "median_therms_per_sqft": 0,
    "min_kwh_per_sqft": 0,
    "max_kwh_per_sqft": 0,
    "min_therms_per_sqft": 0,
    "max_therms_per_sqft": 0,
    "kwh_rates": [],
    "therm_rates": []
}

const AnnualEnergyTargetSuggestions:FC<IProps> = (props) => {
    const { id } = props;
    const [ suggestions, setSuggestions ] = useState<Suggestion>(defaultSuggestion);        


    useEffect(() => {
        const fetchSuggestions = async () => {
            const token = `Token ${(localStorage.getItem("token") || "").slice(1, -1)}`;
            const res = await getSuggestions(token, id);            
            if (res.status !== "error") {
                setSuggestions(res.data);
            }
        };

        fetchSuggestions();
    }, [id]);

    return<div style={{border:'3px solid #444', 
            backgroundColor:'#444', 
            padding:'1rem', 
            margin:'1rem 0',
            borderRadius:'8px'}}>
            <div style={{textAlign:'center', marginBottom:'0.5rem', fontSize:'1.2rem', fontWeight:'bold'}}>
                Similar AI Buildings
            </div>
            <IonRow >
                <div style={{textAlign:'center', marginTop:'1rem',width:'100%'}}>kWh/ft<sup>2</sup> Distribution</div>
                <BoxPlot data={suggestions.kwh_rates} useContainerWidth={true}/>
                <div style={{textAlign:'center', marginTop:'1rem',width:'100%'}}>therms/ft<sup>2</sup> Distribution</div>
                <BoxPlot data={suggestions.therm_rates} useContainerWidth={true}/>
            
        </IonRow>
        </div>
};

export default AnnualEnergyTargetSuggestions;